import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function SuperLoginAttempts() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/super/login-attempts").then(({ data }) => setItems(data));
  }, []);

  return (
    <div className="space-y-6" data-testid="super-login-attempts-page">
      <div>
        <div className="text-xs uppercase tracking-[0.25em] text-zinc-500">Security</div>
        <h1 className="font-serif text-4xl tracking-tighter mt-1 text-white">Login attempts</h1>
      </div>

      <div className="bg-[#18181B] border border-white/5 rounded-md overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="border-white/5">
              <TableHead className="text-zinc-400">Email</TableHead>
              <TableHead className="text-zinc-400">IP</TableHead>
              <TableHead className="text-zinc-400">Attempts</TableHead>
              <TableHead className="text-zinc-400">Status</TableHead>
              <TableHead className="text-zinc-400">Updated</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.length === 0 ? (
              <TableRow><TableCell colSpan={5} className="text-center text-sm text-zinc-500 py-10">No login attempts.</TableCell></TableRow>
            ) : items.map((item) => (
              <TableRow key={item.id || item.identifier} className="border-white/5 hover:bg-white/5">
                <TableCell className="text-zinc-200">{item.email || "—"}</TableCell>
                <TableCell className="text-zinc-400">{item.ip || "—"}</TableCell>
                <TableCell className="text-zinc-300">{item.count || 0}</TableCell>
                <TableCell>
                  <Badge variant="outline" className={item.status === "locked" ? "bg-amber-900/40 text-amber-300 border-amber-800" : "bg-emerald-900/40 text-emerald-300 border-emerald-800"}>{item.status}</Badge>
                </TableCell>
                <TableCell className="text-zinc-400">{item.updated_at ? new Date(item.updated_at).toLocaleString() : "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
